/* eslint-disable @babel/no-invalid-this */
export function renderScrollbars() {
	const scrollableChilds = this.nodes.filter(n => n.hasScrollbar && n.children);

	// console.log(scrollableChilds);
	const scroll = this.container.selectAll("rect.scroll-track").data(scrollableChilds);

	scroll
		.enter()
		.append("rect")
		.attr("id", d => {
			return `${d.id}-scroll-track`;
		})
		.attr("class", "scroll-track")
		.attr("visibility", "hidden")
		.attr("x", d => {
			return d.x + this.nodeSize.width - 10;
		})
		.attr("y", d => {
			return d.y + this.nodeSize.height + 4;
		})
		.attr("rx", 8)
		.attr("ry", 8)
		.attr("width", 10)
		.attr("height", d => {
			return d.max * (this.childNodeSize.height + 4) - 4;
		})
		.attr("stroke", "var(--dashboard-element)")
		.attr("fill", "var(--dashboard-background)")
		.attr("stroke-width", 1);

	scroll
		.enter()
		.append("rect")
		.attr("id", d => {
			return `${d.id}-scroll`;
		})
		.attr("class", "scroll")
		.attr("visibility", "hidden")
		.attr("rx", 8)
		.attr("ry", 8)
		.attr("x", d => {
			return d.x + this.nodeSize.width - 10;
		})
		.attr("y", d => {
			const baseY = d.y + this.nodeSize.height + 4;
			const totalHeight = d.max * (this.childNodeSize.height + 4) - 4;
			const singleNodeScrollH = totalHeight / d.children.length;
			return baseY + singleNodeScrollH * d.offset;
		})
		.attr("width", 10)
		.attr("height", d => {
			const totalHeight = d.max * (this.childNodeSize.height + 4) - 4;

			return (totalHeight * d.max) / d.children.length;
		})
		// .attr("stroke", "var(--dashboard-background)")
		// .attr("stroke-width", 1)
		.attr("fill", "var(--dashboard-element)");

	const paginationFooter = this.container
		.selectAll("rect.pagination-footer")
		.data(scrollableChilds)
		.enter()
		.append("g")
		.attr("id", d => {
			return `${d.id}-pagination-footer`;
		})
		.attr("class", "pagination-footer-wrapper");
	paginationFooter
		.append("rect")
		.attr("id", d => {
			return `${d.id}-scroll`;
		})
		.attr("class", d => {
			let baseClass = "pagination-footer";
			if (d.offset !== d.children.length - d.max) {
				baseClass += " shadow";
			}
			return baseClass;
		})
		.attr("rx", 4)
		.attr("ry", 4)
		.attr("x", d => {
			return d.paginationFooter.x;
		})
		.attr("y", d => {
			return d.paginationFooter.y;
		})
		.attr("width", this.childNodeSize.width)
		.attr("height", this.childNodeSize.height)
		.attr("fill", "var(--dashboard-element)");

	paginationFooter
		.append("text")
		.attr("class", "pagination-message")
		.text(d => {
			return `${d.offset + 1} - ${d.offset + d.max} of ${d.children.length}`;
		})
		.attr("x", d => {
			return d.paginationFooter.x + this.childNodeSize.width - 12;
		})
		.attr("y", d => {
			return d.paginationFooter.y + this.childNodeSize.height / 2;
		})
		.attr("dominant-baseline", "middle")
		.attr("text-anchor", "end")
		.attr("fill", "var(--dashboard-font-light)");
	paginationFooter
		.append("text")
		.attr("class", "pagination-dots")
		.text(() => {
			return "···";
		})
		.attr("x", d => {
			return d.paginationFooter.x + 8;
		})
		.attr("y", d => {
			return d.paginationFooter.y + this.childNodeSize.height / 2;
		})
		.attr("dominant-baseline", "middle")
		.attr("text-anchor", "start")
		.attr("fill", "var(--dashboard-font-light)");
	paginationFooter
		.append("text")
		.attr("class", "pagination-plus-more")
		.text(d => {
			const remaining = d.children.length - (d.offset + d.max);
			return remaining > 0 ? `+${remaining} More` : "";
		})
		.attr("x", d => {
			return d.paginationFooter.x + 36;
		})
		.attr("y", d => {
			return d.paginationFooter.y + this.childNodeSize.height / 2;
		})
		.attr("dominant-baseline", "middle")
		.attr("text-anchor", "start")
		.attr("fill", "var(--dashboard-font-light)");
}
